import { getResourceTo } from 'react/utils/utils';

Greenmile.Event = Greenmile.Event || {};

Greenmile.Event.Validator = {
  validateEventGeoTabToSave(validation) {
    const geoTabEventsOff = App.Views.Event.getEventsGeoTabOff();
    const size = geoTabEventsOff.length;

    if (size) {
      validation.status = false;
      for (let i = 0; i < size; i++) {
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            `${geoTabEventsOff[i].externalDescription} ${Monet.I18n.getResourcesByKey('Greenmile.Event.geotabEventIsOff')}`)
        );
      }
    }

    return validation;
  },

  validateEventDeliveryAlertSMS(validation) {
    const smsBodyField = document.querySelector('#Event #action_delivery_alert_textarea');
    const inputSMSTextArea = document.querySelector('#action_delivery_alert_textarea');

    let smsTextValidator = {};

    const changeClassNameOfInput = (input, setErrorClass) => {
      const smsInput = input;
      let classNameOfInput = smsInput.parentNode.className;

      if (setErrorClass) {
        if (classNameOfInput.search('error') === -1) {
          classNameOfInput += ' error';
        }
      } else {
        classNameOfInput = classNameOfInput.replace('error', '').trim();
      }
      smsInput.parentNode.className = classNameOfInput;
    };

    const smsInputValidator = (input) => {
      let isSMSEmpty = false;
      let isSMSInvalid = false;
      let hasMultipleLinks = false;

      if (!input.value) {
        isSMSEmpty = true;
      } else {
        const linksFound = (input.value.match(/@myorder.link@/g) || []).length;
        isSMSInvalid = linksFound === 0;
        hasMultipleLinks = linksFound > 1;
      }
      return {
        isSMSEmpty,
        isSMSInvalid,
        hasMultipleLinks
      };
    };

    if (inputSMSTextArea && !inputSMSTextArea.hasAttribute('disabled')) {
      if (smsBodyField) {
        smsTextValidator = smsInputValidator(smsBodyField);
        changeClassNameOfInput(smsBodyField, smsTextValidator.isSMSInvalid || smsTextValidator.isSMSEmpty || smsTextValidator.hasMultipleLinks);
      }
    }

    if (smsTextValidator.isSMSEmpty) {
      validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
        'general.mandatoryField', Monet.I18n.getResourcesByKey('event.sms.label')
      ));
    } else if (smsTextValidator.isSMSInvalid) {
      validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('event.SMSMissingDownloadLink'));
    } else if (smsTextValidator.hasMultipleLinks) {
      validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('event.hasMultipleLinks'));
    }
  },

  validateEventActionEmail(validation) {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailContainer = document.querySelector('#Event .hideShowActionEmailTo');
    const actionEmailFromField = document.querySelector('#Event #action_email_from');
    const deliveryAlertFromField = document.querySelector('#delivery_alert_action_from_field');
    const accountTypesContainer = document.querySelector('#Event .accounttype-container');
    const subjectField = document.querySelector('#Event #action_email_subject');
    const deliveryAlertSubjectField = document.querySelector('#delivery_alert_action_subject');
    const emailBodyField = document.querySelector('#Event #action_email_body');
    const deliveryAlertEmailBodyField = document.querySelector('#Event #action_delivery_email_body');

    let emailToValidatorInfo = {};
    let emailFromValidatorInfo = {};
    let deliveryAlertFromValidatorInfo = {};

    const changeClassNameOfInput = (input, setErrorClass) => {
      const emailInput = input;
      let classNameOfInput = emailInput.parentNode.className;

      if (setErrorClass) {
        if (classNameOfInput.search('error') === -1) {
          classNameOfInput += ' error';
        }
      } else {
        classNameOfInput = classNameOfInput.replace('error', '').trim();
      }
      emailInput.parentNode.className = classNameOfInput;
    };

    //expects emails to be a single string with many e-mails separated by semicolon
    const validateMultipleEmails = (emails) => {
      const emailArray = emails.split(';');
      return emailArray.every(email => emailRegex.test(email.trim()));
    };
    //expects email to be a string
    const validateSingleEmail = (email) => {
      return emailRegex.test(email.trim())
    };

    const emailInputValidator = (input, allowMultipleEmails) => {
      let isEmailEmpty = false;
      let isEmailInvalid = false;

      if (!input.value) {
        isEmailEmpty = true;
      } else if (allowMultipleEmails) {
        isEmailInvalid = !validateMultipleEmails(input.value);
      } else {
        isEmailInvalid = !validateSingleEmail(input.value);
      }

      return {
        isEmailEmpty,
        isEmailInvalid
      };
    };

    if (emailContainer && !emailContainer.classList.contains('hideField')) {
      const actionEmailTo = emailContainer.querySelector('#action_email_to');
      emailToValidatorInfo = emailInputValidator(actionEmailTo, true);
      changeClassNameOfInput(actionEmailTo, emailToValidatorInfo.isEmailEmpty || emailToValidatorInfo.isEmailInvalid);
    }

    if (actionEmailFromField && !actionEmailFromField.disabled) {
      emailFromValidatorInfo = emailInputValidator(actionEmailFromField, false);
      changeClassNameOfInput(actionEmailFromField, emailFromValidatorInfo.isEmailEmpty || emailFromValidatorInfo.isEmailInvalid);
    }

    if (deliveryAlertFromField && !deliveryAlertFromField.disabled) {
      deliveryAlertFromValidatorInfo = emailInputValidator(deliveryAlertFromField, false);
      changeClassNameOfInput(deliveryAlertFromField, deliveryAlertFromValidatorInfo.isEmailEmpty || deliveryAlertFromValidatorInfo.isEmailInvalid);
    }

    if (emailToValidatorInfo.isEmailEmpty || emailFromValidatorInfo.isEmailEmpty || deliveryAlertFromValidatorInfo.isEmailEmpty) {
      validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('Event.emailIsRequired'));
    } else if (emailToValidatorInfo.isEmailInvalid || emailFromValidatorInfo.isEmailInvalid || deliveryAlertFromValidatorInfo.isEmailInvalid) {
      validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('Event.emailInvalidFormat'));
    }

    if (accountTypesContainer && !accountTypesContainer.classList.contains('hideField')) {
      const accountTypeIdField = accountTypesContainer.querySelector('#accountTypes_id');
      const acountTypeIsInvalid = !App.Forms.EventLookupAccountTypeEmail.lookupElement.getValue().length;
      if (acountTypeIsInvalid) {
        validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
          'general.mandatoryField', Monet.I18n.getResourcesByKey('location.accountType')
        ));
      }
      changeClassNameOfInput(accountTypeIdField, acountTypeIsInvalid);
    }

    if (subjectField && !subjectField.hasAttribute('disabled')) {
      const subjectFieldIsEmpty = !subjectField.value;
      if (subjectFieldIsEmpty) {
        validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
          'general.mandatoryField', Monet.I18n.getResourcesByKey('event.email.subject')
        ));
      }
      changeClassNameOfInput(subjectField, subjectFieldIsEmpty);
    }

    if (deliveryAlertSubjectField && !deliveryAlertSubjectField.hasAttribute('disabled')) {
      const deliveryAlertSubjectFieldIsEmpty = !deliveryAlertSubjectField.value;
      if (deliveryAlertSubjectFieldIsEmpty) {
        validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
          'general.mandatoryField', Monet.I18n.getResourcesByKey('event.email.subject')
        ));
      }
      changeClassNameOfInput(deliveryAlertSubjectField, deliveryAlertSubjectFieldIsEmpty);
    }

    if (emailBodyField) {
      const emailBodyIsEmpty = emailBodyField.firstElementChild.innerHTML === '<p><br></p>';
      if (emailBodyIsEmpty) {
        validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
          'general.mandatoryField', Monet.I18n.getResourcesByKey('event.email.body')
        ));
      }
      changeClassNameOfInput(emailBodyField, emailBodyIsEmpty);
    }

    if (deliveryAlertEmailBodyField) {
      if (App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor && App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor.isEnabled()) {
        const emailBodyIsEmpty = deliveryAlertEmailBodyField.firstElementChild.innerHTML === '<p><br></p>';

        const isEmailLinkValid = App.Forms.Event.Actions.DeliveryAlert.richDeliveryEditor.container.firstElementChild.innerText.includes('@myorder.link@');

        if (emailBodyIsEmpty) {
          validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
            'general.mandatoryField', Monet.I18n.getResourcesByKey('event.email.body')
          ));
        } else if (!isEmailLinkValid) {
          validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('event.emailMissingDownloadLink'));
        }
        changeClassNameOfInput(deliveryAlertEmailBodyField, emailBodyIsEmpty || !isEmailLinkValid);
      }
    }

    if (validation.errorMessages && validation.errorMessages.length) {
      validation.status = false;
    }

    return validation;
  },

  validateEventActionSms(validation) {
    const smsTextField = document.querySelector('#Event #action_sms_text');
    const smsTextContainerField = document.querySelector('#Event .sms-text-container');

    if (smsTextContainerField) {
      if (smsTextField && smsTextField.value.length > smsTextField.maxLength) {
        smsTextContainerField.classList.add("error");
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey('event.sms.maxMessage', 1414))
        );
        validation.status = false;
      } else {
        smsTextContainerField.classList.remove("error");
      }
    }

    return validation;
  },

  validateEventMessage(validation) {
    const availableTags = Greenmile.Event.AutoComplete.availableTags;
    const matches = App.Forms.Event.form.fields.messageBody.getValue().match(/@(\S*)@/g) || [];
    const validTags = matches.reduce((acc, match) => {
      if (availableTags.indexOf(match.replace(/@/g, '')) !== -1) {
        acc.push(match);
      }
      return acc;
    }, []);

    if (validTags.length !== matches.length) {
      validation.status = false;
      validation.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject('Greenmile.Event.invalidAttribute')
      );
    }
    return validation;
  },

  validateEventMovementNotAllowed(validation) {
    let inputFieldNotFilled = '';
    let checkboxOffdutyNotEnabled = '';
    let checkboxLunchNotEnabled = '';

    const checkboxLunch = document.querySelector('.movement-not-allowed #lunch-checkbox');
    const lunchRadius = document.querySelector('.movement-not-allowed #lunch-radius');
    const checkboxOffduty = document.querySelector('.movement-not-allowed #offduty-checkbox');
    const offdutyRadius = document.querySelector('.movement-not-allowed #offduty-radius');

    if (lunchRadius) {
      const ERROR_CLASS = ' error';

      lunchRadius.className = lunchRadius.className.replace(ERROR_CLASS, '')
      offdutyRadius.className = offdutyRadius.className.replace(ERROR_CLASS, '');

      if (checkboxOffduty.checked && !offdutyRadius.value) {
        inputFieldNotFilled = 'event.check.movementNotAllowed.offDutyRadius';
        offdutyRadius.className += ERROR_CLASS;
      }
      if (checkboxLunch.checked && !lunchRadius.value) {
        inputFieldNotFilled = 'event.check.movementNotAllowed.lunchRadius';
        lunchRadius.className += ERROR_CLASS;
      }

      if (!checkboxLunch.checked && !checkboxOffduty.checked) {
        checkboxOffdutyNotEnabled = 'event.check.movementNotAllowed.offDutyRadius';
        offdutyRadius.className += ERROR_CLASS;
        checkboxLunchNotEnabled = 'event.check.movementNotAllowed.lunchRadius';
        lunchRadius.className += ERROR_CLASS;
      }

      if (inputFieldNotFilled) {
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            `${Monet.I18n.getResourcesByKey(inputFieldNotFilled)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
        );
        validation.status = false;
      }

      if (checkboxLunchNotEnabled && checkboxOffdutyNotEnabled) {
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            `${Monet.I18n.getResourcesByKey(checkboxLunchNotEnabled)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
        );
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            `${Monet.I18n.getResourcesByKey(checkboxOffdutyNotEnabled)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
        );
        validation.status = false;
      }
    }

    return validation;
  },

  validateEventOnOffDutyAlert(validation) {
    const timeToCheck = document.querySelector('.on-off-duty-alert-time #time_to_check');
    if (timeToCheck && timeToCheck.value.length < 5) {
      validation.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          `${Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.timeToCheck')} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
      );
      validation.status = false
    }
    return validation;
  },

  validateEventUnplannedStop(validation) {
      const input = document.querySelector('#unplanned_stop_time_minutes');
      if (input) {
        const fieldResourceKey = 'event.check.unplanned.timeMinutes';
        const pattern = new RegExp('[^0-9]');

        if (!input.value) {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKey)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
          );
          validation.status = false;

        } else if (pattern.test(input.value)) {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKey)} ${Monet.I18n.getResourcesByKey('general.integerField.errorPositiveInt')}`)
          );
          validation.status = false;
        }
      }

      return validation;
    },

  validateEventServiceTime(validation) {
    const combo = document.querySelector('#service_time_combo');
    const input = document.querySelector('#service_time_param');

    if (input) {
      const fieldResourceKeyPercentual = 'event.servicetime.rule.percentual';
      const fieldResourceKeyFixed = 'event.servicetime.rule.fixed';
      const pattern = new RegExp('[^0-9]');

      if (!input.value) {
        if (combo.value === 'percentual') {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKeyPercentual)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
          );
          validation.status = false;
        } else {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKeyFixed)} ${Monet.I18n.getResourcesByKey('error.isrequired')}`)
          );
          validation.status = false;
        }
      } else if (pattern.test(input.value)) {
        if (combo.value === 'percentual') {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKeyPercentual)} ${Monet.I18n.getResourcesByKey('general.integerField.errorPositiveInt')}`)
          );
          validation.status = false;
        } else {
          validation.errorMessages.push(
            Monet.Form.Messages.mountErrorMessageObject(
              `${Monet.I18n.getResourcesByKey(fieldResourceKeyFixed)} ${Monet.I18n.getResourcesByKey('general.integerField.errorPositiveInt')}`)
          );
          validation.status = false;
        }
      }
    }
  },

  validateEventDriversCongregation(validation) {
    const input = document.querySelector('#drivers_congregation_time_minutes');

    if (input) {
      const fieldResourceKey = Monet.I18n.getResourcesByKey('event.check.driversCongregation.timeMinutes');
      const pattern = new RegExp('[^0-9]');

      if (!input.value) {
        this.pushErrorMessage(validation, fieldResourceKey, 'error.isrequired');

      } else if (pattern.test(input.value)) {
        this.pushErrorMessage(validation, fieldResourceKey, 'general.integerField.errorPositiveInt');
      }
    }

    return validation;
  },

  validateAuthMethodField(validation) {
    const authMethod = $('#authentication-method').val();
    const basicAuthCheckResourceKey = getResourceTo(
        'event.check.postRequestAction.basicAuth'
      );
      const bearerTokenCheckResourceKey = getResourceTo(
        'event.check.postRequestAction.bearerToken'
      );
      const apiKeyCheckResourceKey = getResourceTo(
        'event.check.postRequestAction.apiKey'
      );

     switch (authMethod) {
        case 'basic-authentication':
          const user = $('#username').val();
          const pass = $('#password').val();

          if (!user.length && !pass.length) {
            $('#username').addClass('error');
            $('#password').addClass('error');
            this.pushErrorMessage(
              validation,
              basicAuthCheckResourceKey,
              'error.isrequired'
            );
          }
          break;
        case 'bearer-token':
          const token = $('#token').val();

          if (!token.length) {
            $('#token').addClass('error');
            this.pushErrorMessage(
              validation,
              bearerTokenCheckResourceKey,
              'error.isrequired'
            );
          }
          break;
        case 'api-key':
          const key = $('#key').val();
          const value = $('#value').val();

          if (!key.length && !value.length) {
            $('#key').addClass('error');
            $('#value').addClass('error');
            this.pushErrorMessage(
              validation,
              apiKeyCheckResourceKey,
              'error.isrequired'
            );
          }
          break;
        default:
          break;
      }
  },

  validateEventActionHttpRequest(validation) {
    const urlField = $('#action_http_url');
    const dataField = $('#post_request_data > textarea');
    const postRequestContainer = $('.post-request-container');
    const postRequestData = $('#post_request_data > textarea').val();

    const dataCheckResourceKey = getResourceTo(
      'event.check.postRequestAction.data'
    );

    const {
      validateURL,
      validateData,
      clearErrors
    } = Greenmile.Event.EventActionUtil.postRequestActionValidate(this.pushErrorMessage);

    clearErrors(urlField, dataField);

    if (!postRequestContainer.length) {
      this.validateAuthMethodField(validation);

      return validation;
    }

    validateURL(urlField, validation);
    validateData(dataField, validation);

    this.validateAuthMethodField(validation);

    try {
      JSON.parse(postRequestData);
      $('.post_request_data').removeClass('error');
    } catch (error) {
      $('.post_request_data').addClass('error');
      this.pushErrorMessage(
        validation,
        dataCheckResourceKey,
        "event.http.data.errorMessageJson"
      );
    }

    return validation;
  },

  pushErrorMessage(validation, fieldResourceKey, resourceString) {
    validation.errorMessages.push(
      Monet.Form.Messages.mountErrorMessageObject(
        `${fieldResourceKey} ${Monet.I18n.getResourcesByKey(resourceString)}`)
    );
    validation.status = false;
  },

  validateEvents(validation) {
    const checkEvent = App.Forms.Event.form.rootEl.querySelector('[key$="check_event"]');
    const actionEvent = App.Forms.Event.form.rootEl.querySelector('[key$="action_event"]');

    // validate rules fields
    if (checkEvent) {
      const boxEvent = checkEvent.querySelectorAll('.box-event');
      boxEvent.forEach((box) => {
        const namespaceInputElement = box.querySelector('input[type="hidden"][name="namespace"]');
        const namespace = namespaceInputElement && namespaceInputElement.value;
        const { validateParameter } = Greenmile.Checks.EventCheck[namespace] || {};
        if (typeof validateParameter === 'function') {
          validateParameter(validation);
        }
      });
    }

    // validate actions fields
    if (actionEvent) {
      const boxEvent = actionEvent.querySelectorAll('.box-event');
      boxEvent.forEach((box) => {
        const namespaceInputElement = box.querySelector('input[type="hidden"][name="namespace"]');
        const namespace = namespaceInputElement && namespaceInputElement.value;
        const { validateParameter } = Greenmile.Actions[namespace] || {};
        if (typeof validateParameter === 'function') {
          validateParameter(validation);
        }
      });
    }

    Greenmile.Event.Validator.validateEventGeoTabToSave(validation);
    Greenmile.Event.Validator.validateEventMessage(validation);
    Greenmile.Event.Validator.validateEventActionEmail(validation);
    Greenmile.Event.Validator.validateEventActionSms(validation);
    Greenmile.Event.Validator.validateEventDeliveryAlertSMS(validation);
    Greenmile.Event.Validator.validateEventMovementNotAllowed(validation);
    Greenmile.Event.Validator.validateEventOnOffDutyAlert(validation);
    Greenmile.Event.Validator.validateEventUnplannedStop(validation);
    Greenmile.Event.Validator.validateEventDriversCongregation(validation);
    Greenmile.Event.Validator.validateEventServiceTime(validation);
    Greenmile.Event.Validator.validateEventActionHttpRequest(validation);


    return validation;
  }
};
